package kz.dentalcrm.app.core.ui

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.scaleIn
import androidx.compose.animation.scaleOut
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.focusable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.size
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import kz.dentalcrm.app.core.ui.components.InfiniteProgress
import kz.dentalcrm.app.theme.DefaultTheme

@Composable
fun UiStateScaffold(
    modifier: Modifier,
    isLoading: Boolean = false,
    uiError: UiError? = null,
    content: @Composable () -> Unit,
) {
    Box(
        modifier = Modifier.
            background(
                color =  DefaultTheme.colors.surfaceBackground
            )
            .then(modifier)
    ) {
        content()

        AnimatedVisibility(
            visible = isLoading,
            enter = fadeIn(),
            exit = fadeOut()
        ) {
            Box(
                modifier = Modifier
                    .background(Color(0x66000000))
                    .fillMaxSize()
                    .focusable(true)
                    .clickable(
                        indication = null,
                        interactionSource = remember { MutableInteractionSource() }) {},
                contentAlignment = Alignment.Center,
            ) {
                AnimatedVisibility(
                    visible = isLoading,
                    enter = scaleIn(),
                    exit = scaleOut()
                ) {
                    InfiniteProgress(
                        modifier = Modifier.size(44.dp),
                        strokeWidth = 6.dp,
                    )
                }
            }
        }

        AnimatedVisibility(
            visible = uiError != null,
            enter = scaleIn(),
            exit = scaleOut()
        ) {

        }
    }
}